import React, {useEffect, useState} from 'react'
import {ArrowUp} from "lucide-react";

function BackToTop() {
    const [scroll, setScroll] = useState(0);

    useEffect(() => {
        const handleScroll = () => setScroll(window.scrollY);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [])

    const backToTop = () => window.scrollTo(0, 0);

    return (
        <a
            onClick={backToTop}
            className={`fixed right-4 bottom-4 z-[99999] flex items-center justify-center w-10 h-10 rounded bg-[#4154f1] hover:bg-[#6776f4] transition-all duration-300 cursor-pointer
                ${scroll > 100 ? 'visible opacity-100' : 'invisible opacity-0'}`}
        >
            <ArrowUp className='bi bi-arrow-up-short text-2xl text-white leading-none' />
        </a>
    );
}

export default BackToTop